export function normalFetch(
    url: string,
    fetchOptions: RequestInit | undefined
): Promise<Response> {
    return new URL(url).pathname.endsWith('contents') && fetchOptions
        ? fetch(url, fetchOptions)
        : fetch(url);
}

// custom fetch with XMLHttpRequest to avoid timeout
export function customFetch(
    url: string,
    accessToken?: string,
    type?: string
): Promise<Response> {

    const fetchOptions = {
        method: 'GET',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Authorization: 'Bearer ' + accessToken,
        },
    };

    if (window.navigator.onLine) {
        return new Promise(function (resolve) {
            const xml = new XMLHttpRequest();
            xml.open('GET', url, true);
            xml.setRequestHeader('Service-Worker', 'false');

            if (
                new URL(url).pathname.endsWith('contents') || new URL(url).pathname.includes('assets') &&
                fetchOptions?.headers
            ) {
                const headers = fetchOptions.headers as Record<string, string>;

                for (const key in headers) {
                    if (Object.prototype.hasOwnProperty.call(headers, key)) {
                        xml.setRequestHeader(key, headers[key]);
                    }
                }
            }
            xml.responseType = 'blob';
            xml.onload = function () {
                if (xml.status > 599) {
                    resolve(normalFetch(url, fetchOptions));
                } else {
                    var blob = xml.response;
                    if (type) {
                        blob = new Blob([blob], { type: type });
                    }
                    var myResponse = new Response(
                        xml.status === 200 ? blob : null,
                        {
                            status: xml.status,
                            statusText: xml.statusText,
                        }
                    );
                    resolve(myResponse);
                }
            };
            xml.onerror = function () {
                resolve(normalFetch(url, fetchOptions));
            };
            xml.send();
        });
    }
    return normalFetch(url, fetchOptions);
}
